import { post } from '@axios';
import { showLoader, hideLoader } from 'actions/loader';
import { requests } from 'shared/requests';
import { SHOW_ERROR_MODAL } from 'actions/errorModal';

const getDesigns = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let designs = await post({ url: requests.getDesigns, data });
      if (designs?.resources?.length) {
        for (let i = 0; i < designs?.resources?.length; i++) {
          designs.resources[i].secure_url = designs?.resources[
            i
          ].secure_url.replace('.pdf', '.png');
        }
      }
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const clearArtWork = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const designs = await post({ url: requests.clearArtWork, data });
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const getPreDesigns = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const designs = await post({ url: requests.getPreDesigns, data });
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const getPhraseDesigns = (cursor) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const designs = await post({
        url: requests.GetPhraseDesigns,
        data: { tag: 'ShirtlyPhrases', next_cursor: cursor },
      });
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const getPlusArtFiles = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let designs = await post({
        url: requests.getPlusArtFiles,
        data,
      });
      if (designs?.resources?.length) {
        for (let i = 0; i < designs?.resources?.length; i++) {
          designs.resources[i].secure_url = designs?.resources[
            i
          ].secure_url.replace('.pdf', '.png');
        }
      }
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const getStaplesDesigns = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const designs = await post({ url: requests.getStaplesDesigns, data });
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const clearStaplesArtwork = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const designs = await post({ url: requests.clearStaplesArtwork, data });
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const searchDesigns = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const designs = await post({ url: requests.searchDesigns, data });
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

const searchBOTDesigns = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const designs = await post({ url: requests.searchBOTDesigns, data });
      dispatch(hideLoader());
      return designs;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      return { error: true, message: error.message };
    }
  };
};

export {
  searchBOTDesigns,
  getDesigns,
  clearArtWork,
  getPreDesigns,
  getPhraseDesigns,
  getPlusArtFiles,
  getStaplesDesigns,
  clearStaplesArtwork,
  searchDesigns,
};
